import { render, staticRenderFns } from "./CarrouselPropio.vue?vue&type=template&id=cb116fe4&scoped=true&"
import script from "./CarrouselPropio.vue?vue&type=script&lang=js&"
export * from "./CarrouselPropio.vue?vue&type=script&lang=js&"
import style0 from "./CarrouselPropio.vue?vue&type=style&index=0&id=cb116fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb116fe4",
  null
  
)

export default component.exports